import axios from 'axios';

export const baseURL = 'https:///service2.jansnak.com/site/data';
// export const baseURL = 'https://api.jansnak.com/api/base';



export const customHeaders = {
  Accept: "text/plain",
  'X-Auth-code': 'SASC2!3@cJHdnbbcydy51ScpS#*hhb51xc@WsJHVG2_23bPCe65',

};



export default axios.create({
  baseURL,
  headers: customHeaders,


});



